import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ngx-fullpage-loader',
  templateUrl: './ngx-fullpage-loader.component.html',
  styleUrls: ['./ngx-fullpage-loader.component.scss']
})
export class NgxFullpageLoaderComponent implements OnInit {

  @Input() label: string = 'Loading...';

  constructor() { }

  ngOnInit(): void {
  }

}
